module.exports = "/_next/static/images/06482a9510bb3ae9e957b099d9a44ceb-secured-pre-ric.svg.webp";